import PropTypes from 'prop-types';

import StoreAvailabilityLoggedIn from './StoreAvailabilityLoggedIn';
import StoreAvailabilityLoggedOut from './StoreAvailabilityLoggedOut';

const StoreAvailability = ({ isUserLogged, slug, sizeId, productColorId }) =>
  isUserLogged ? (
    <StoreAvailabilityLoggedIn
      sizeId={sizeId}
      slug={slug}
      productColorId={productColorId}
    />
  ) : (
    <StoreAvailabilityLoggedOut
      slug={slug}
      productColorId={productColorId}
    />
  );

StoreAvailability.propTypes = {
  isUserLogged: PropTypes.bool.isRequired,
  slug: PropTypes.string.isRequired,
  sizeId: PropTypes.string.isRequired,
  productColorId: PropTypes.string.isRequired,
};

export default StoreAvailability;
